import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Observable, from, BehaviorSubject, of } from "rxjs";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { concatMap, take, map, toArray } from "rxjs/operators";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CatalogoService } from "src/app/services/catalogo.service";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { UsuarioService } from "src/app/services/usuario.service";
import { Usuario } from "src/app/models/entities/usuario";
import { AprobacionLevantamientoObraDto } from "src/app/models/dtos/aprobacion-levantamiento-obra-dto";
import { Estado } from "src/app/models/entities/estado";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { AlertasService } from "src/app/services/alertas.service";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { LatLngBounds } from "@agm/core";
import { SegmentoService } from "src/app/services/segmento.service";
import { Segmento } from "src/app/models/entities/segmento";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { Coordenada } from "src/app/models/entities/coordenada";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { Obra } from "src/app/models/entities/obra";
import { ObraService } from "src/app/services/obra.service";
import { ArchivoCoordenadaService } from "../../../../services/archivo-coordenada.service";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { UsuariosAsignadosService } from "../../../../services/usuarios-asignados.service";
import { Alert } from "../../../../models/alert";
declare const google: any;

@Component({
  selector: "aprobacion-levatamiento-obras",
  templateUrl: "./aprobacion-levatamiento-obras.component.html",
  styleUrls: ["./aprobacion-levatamiento-obras.component.scss"],
})
export class AprobacionLevatamientoObrasComponent implements OnInit {
  @ViewChild("modalAprobracionLevantamientoObra")
  public modalAprobacionObra: any;
  public modalActivoAprobacionObra: NgbModalRef;
  @ViewChild("modalRechazoLevantamientoObra")
  public modalRechazoObra: any;
  public modalActivoRechazoObra: NgbModalRef;
  @ViewChild("modalEliminarLevantamientoObra")
  public modalEliminarObra: any;
  public modalActivoEliminarObra: NgbModalRef;
  @ViewChild("modalBorrarLevantamientoObra")
  public modalBorrarLevantamientoObra: any;
  public modalActivoBorrarLevantamientoObra: NgbModalRef;
  public obrasLevantamiento$: Observable<LevantamientoObra[]> = null;
  public obrasLevantamiento: LevantamientoObra[] = [];
  public datos$: Observable<AprobacionLevantamientoObraDto[]> = null;
  public catalogoDireccionAdjunta: ElementoCatalogo[] = [];
  public catalogoEstados: Estado[] = [];
  public catalogoEstatusValidacionObra: ElementoCatalogo[] = [];
  public catalogoTipoLevantamiento: ElementoCatalogo[] = [];
  public catalogoTipoObra: ElementoCatalogo[] = [];
  public catalogoColores: ElementoCatalogo[] = [];
  public obraLevantamientoSeleccionada: AprobacionLevantamientoObraDto;
  public readonly fechaActual: number = new Date().getTime();
  public usuarioEnSesion: UsuarioSesionDTO = null;
  public readonly OBRA_APROBADA: string = "2";
  public readonly OBRA_RECHAZADA: string = "1";
  public readonly APROBADA: string = "Aprobada";
  public readonly RECHAZADA: string = "Rechazada";
  public readonly PENDIENTE: string = "Pendiente";

  @ViewChild("switch") switch: ElementRef;
  public segmentos: Segmento[] = [];
  public map: any;
  public marcadorInicial: any;
  public marcadorFinal: any;

  public latActual: any;
  public lngActual: any;
  public zoomActual: any;

  public FOTOS_POR_PAGINA = 4;
  public TIPO_OBRA_PROCESO: string = "0";
  public colores: ElementoCatalogo[] = [];
  public datosCoordenadas: any;
  public colorCapa: any;

  public boolInfoMapaLista: boolean = false;
  public datosObraSeleccionada: AprobacionLevantamientoObraDto;

  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly KEY_COLOR_CAPA_PROYECTO_PROCESO: string = "0";
  public readonly KEY_COLOR_CAPA_PROYECTO_PLANEACION: string = "4";
  public HEX_COLOR_CAPA_PROYECTO_PROCESO: string = "";
  public HEX_COLOR_CAPA_PROYECTO_PLANEACION: string = "";
  alert: Alert = new Alert();
  public obrasBehaviorSubject$: BehaviorSubject<
    AprobacionLevantamientoObraDto[]
  > = new BehaviorSubject<AprobacionLevantamientoObraDto[]>(null);
  public cols = [
    { field: "nombreObra", header: "Nombre obra" },
    { field: "estado", header: "Estado" },
    { field: "direccion", header: "Dirección" },
    { field: "estatus", header: "Estatus" },
    { field: "fechaCreacion", header: "Fecha creación" },
    { field: "acciones", header: "Acciones" },
  ];

  public marker: any = {
    url: "../../../../../assets/img/iconos/marker-red.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };

  constructor(
    private levantamientoObraService: LevantamientoObraService,
    private catalogosService: CatalogoService,
    private usuarioService: UsuarioService,
    private ngbModalService: NgbModal,
    private alertasService: AlertasService,
    private facadeSesionService: FacadeSesionService,
    public dateUtils: DateUtils,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private obraService: ObraService,
    private archivoCoord: ArchivoCoordenadaService,
    private usuarioAsignado: UsuariosAsignadosService
  ) {}

  ngOnInit() {
    this.obtenerDatos();

    this.facadeSesionService.usuarioEnSesionService
      .obtenerUsuario()
      .subscribe(
        (usuarioEnSesion: UsuarioSesionDTO) =>
          (this.usuarioEnSesion = usuarioEnSesion)
      );
  }

  public async obtenerDatos() {
    await this.obtenerCatalogos();
    this.datos$ = this.levantamientoObraService.findAll().pipe(
      concatMap((levantamientosObra: LevantamientoObra[]) =>
        from(levantamientosObra).pipe(
          concatMap((levantamientoObra: LevantamientoObra) =>
            this.usuarioService
              .findByKey(levantamientoObra.keyUsuarioLevantamiento)
              .pipe(
                take(1),
                map(
                  (usuario: Usuario) =>
                    ({
                      ...levantamientoObra,
                      nombreDireccionAdjunta: this.catalogoDireccionAdjunta.find(
                        (direccionAdjunta: ElementoCatalogo) =>
                          direccionAdjunta.key ===
                          levantamientoObra.keyCatDireccionAdjunta
                      ).nombre,
                      nombreEstado: this.catalogoEstados.find(
                        (estados: Estado) =>
                          estados.key === levantamientoObra.keyCatEstado
                      ).nombre,
                      nombreEstatusValidacionObra: this.catalogoEstatusValidacionObra.find(
                        (estatus: ElementoCatalogo) =>
                          estatus.key ===
                          levantamientoObra.keyCatEstatusValidacionObra
                      ).nombre,
                      nombreTipoLevantamiento: this.catalogoTipoLevantamiento.find(
                        (tipoLevantamiento: ElementoCatalogo) =>
                          tipoLevantamiento.key ===
                          levantamientoObra.keyCatTipoLevantamiento
                      ).nombre,
                      nombreTipoObra: this.catalogoTipoObra.find(
                        (tipoObra: ElementoCatalogo) =>
                          tipoObra.key === levantamientoObra.keyCatTipoObra
                      ).nombre,
                      usuario,
                    } as AprobacionLevantamientoObraDto)
                ),
                concatMap((aprobLev: AprobacionLevantamientoObraDto) => {
                  if (aprobLev.keyUsuarioAprobacion) {
                    return this.usuarioService
                      .findByKey(aprobLev.keyUsuarioAprobacion)
                      .pipe(
                        take(1),
                        map(
                          (usuarioAprobacion: Usuario) =>
                            ({
                              ...aprobLev,
                              usuarioAprobacion,
                            } as AprobacionLevantamientoObraDto)
                        )
                      );
                  } else {
                    return of("").pipe(
                      take(1),
                      map(
                        (usuarioAprobacion: string) =>
                          ({
                            ...aprobLev,
                            usuarioAprobacion,
                          } as AprobacionLevantamientoObraDto)
                      )
                    );
                  }
                })
              )
          ),
          toArray()
        )
      ),
      take(1)
    );

    this.datos$.subscribe((obras) => {
      this.obrasBehaviorSubject$.next(obras);
    });
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catalogoDireccionAdjunta = await this.catalogosService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catalogoEstados = await this.catalogosService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.catalogoEstatusValidacionObra = await this.catalogosService
      .obtenerCatalogo<ElementoCatalogo>(
        RutaCatalogoEnum.ESTATUS_VALIDACIONES_OBRA
      )
      .pipe(take(1))
      .toPromise();
    this.catalogoTipoLevantamiento = await this.catalogosService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
    this.catalogoTipoObra = await this.catalogosService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catalogoColores = await this.catalogosService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.HEX_COLOR_CAPA_PROYECTO_PROCESO = this.catalogoColores.find(
      (c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PROCESO
    ).nombre;
    this.HEX_COLOR_CAPA_PROYECTO_PLANEACION = this.catalogoColores.find(
      (c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PLANEACION
    ).nombre;
  }

  public abrirModalAprobarObra(obraAprovada: AprobacionLevantamientoObraDto) {
    this.obraLevantamientoSeleccionada = obraAprovada;
    this.modalActivoAprobacionObra = this.ngbModalService.open(
      this.modalAprobacionObra,
      { centered: true, windowClass: "modal-confirmacion" }
    );
  }

  public abrirModalRechazarObra(obraRechazada: AprobacionLevantamientoObraDto) {
    this.obraLevantamientoSeleccionada = obraRechazada;
    this.modalActivoRechazoObra = this.ngbModalService.open(
      this.modalRechazoObra,
      { centered: true, windowClass: "modal-confirmacion" }
    );
  }

  public async actualizarLevantamientoObra(estatusAprobacionObra: string) {
    this.obraLevantamientoSeleccionada.fechaAprobacion = this.fechaActual;
    this.obraLevantamientoSeleccionada.fechaActualizacion = this.fechaActual;
    this.obraLevantamientoSeleccionada.keyUsuarioAprobacion = this.usuarioEnSesion.usuario.key;

    let obraPara = this.obrasBehaviorSubject$
      .getValue()
      .find((obras) => obras.key == this.obraLevantamientoSeleccionada.key);
    obraPara.usuarioAprobacion = await this.usuarioService
      .findByKey(obraPara.keyUsuarioAprobacion)
      .pipe(take(1))
      .toPromise();
    let indice = this.obrasBehaviorSubject$
      .getValue()
      .findIndex(
        (obras) => obras.key == this.obraLevantamientoSeleccionada.key
      );
    let arregloObras = this.obrasBehaviorSubject$.getValue();
    arregloObras[indice] = obraPara;
    this.obrasBehaviorSubject$.next(arregloObras);

    let obraActualizada = { ...this.obraLevantamientoSeleccionada };
    delete obraActualizada.key;
    delete obraActualizada.usuario;
    delete obraActualizada.nombreObra;
    delete obraActualizada.nombreTramoLicitacion;
    delete obraActualizada.nombreDireccionAdjunta;
    delete obraActualizada.nombreEstado;
    delete obraActualizada.nombreEstatusValidacionObra;
    delete obraActualizada.nombreTipoLevantamiento;
    delete obraActualizada.nombreTipoObra;
    delete obraActualizada.usuarioAprobacion;
    if (estatusAprobacionObra === this.OBRA_APROBADA) {
      this.obraLevantamientoSeleccionada.nombreEstatusValidacionObra = this.APROBADA;
      obraActualizada.keyCatEstatusValidacionObra = this.OBRA_APROBADA;
      this.levantamientoObraService
        .update(this.obraLevantamientoSeleccionada.key, obraActualizada)
        .then(() => {
          this.cerrarModalAprobacion();
          this.alertasService.mostrarAlerta("success", "Obra aprobada.");
        });
    } else {
      this.obraLevantamientoSeleccionada.nombreEstatusValidacionObra = this.RECHAZADA;
      obraActualizada.keyCatEstatusValidacionObra = this.OBRA_RECHAZADA;
      await this.levantamientoObraService.update(
        this.obraLevantamientoSeleccionada.key,
        obraActualizada
      );
      this.cerrarModalRechazo();
      this.alertasService.mostrarAlerta("success", "Obra rechazada.");
    }
  }

  public cerrarModalAprobacion() {
    this.modalActivoAprobacionObra.close();
  }

  public cerrarModalRechazo() {
    this.modalActivoRechazoObra.close();
  }

  public abrirModalEliminarObra(obraEliminada: AprobacionLevantamientoObraDto) {
    this.obraLevantamientoSeleccionada = obraEliminada;
    this.modalActivoEliminarObra = this.ngbModalService.open(
      this.modalEliminarObra,
      { centered: true, windowClass: "modal-confirmacion" }
    );
  }
  public abrirModalBorrarLevantamiento(obra: AprobacionLevantamientoObraDto) {
    this.obraLevantamientoSeleccionada = obra;
    this.modalActivoBorrarLevantamientoObra = this.ngbModalService.open(
      this.modalBorrarLevantamientoObra,
      { centered: true, windowClass: "modal-confirmacion" }
    );
    console.log(this.obraLevantamientoSeleccionada.key);
  }

  public eliminarObraSeleccionada() {
    this.levantamientoObraService
      .deleteObra(this.obraLevantamientoSeleccionada.key)
      .then(() => {
        this.obrasBehaviorSubject$.next(
          this.obrasBehaviorSubject$
            .getValue()
            .filter(
              (obra: AprobacionLevantamientoObraDto) =>
                obra.key !== this.obraLevantamientoSeleccionada.key
            )
        );
        this.cerrarModalEliminar();
        this.alertasService.mostrarAlerta("success", "Obra eliminada.");
      });
  }

  public async borrarLevantamientoObraSeleccionada() {
    this.alert.cargando("Eliminado Obra...");
    let capas: Capa[] = [];
    let segmentosCapas: Segmento[] = [];
    capas = await this.capaService
      .findByKeyLevantamientoObra(this.obraLevantamientoSeleccionada.key)
      .pipe(take(1))
      .toPromise();
    if (capas) {
      for (let index = 0; index < capas.length; index++) {
        let segmentos: Segmento[] = await this.segmentoService
          .findByKeyCapa(capas[index].key)
          .pipe(take(1))
          .toPromise();
        if (segmentos) {
          for (let i = 0; i < segmentos.length; i++) {
            segmentosCapas.push(segmentos[i]);
          }
        }
        this.capaService.delete(capas[index].key);
      }
      if (segmentosCapas) {
        for (let indice = 0; indice < segmentosCapas.length; indice++) {
          this.segmentoService.delete(segmentosCapas[indice].key);
        }
      }
    }
    let obraFicha: Obra = await this.obraService
      .findByKeyLevantamientoObra(this.obraLevantamientoSeleccionada.key)
      .pipe(take(1))
      .toPromise();
    if (obraFicha) {
      this.obraService.remove(obraFicha.key);
    }

    // Elimina archivo coordenadas
    let archivosCoords: ArchivoCoordenada[] = [];
    archivosCoords = await this.archivoCoord
      .findByKeyLevantamientoObra(this.obraLevantamientoSeleccionada.key)
      .pipe(take(1))
      .toPromise();
    if (archivosCoords) {
      archivosCoords.forEach((element) =>
        this.archivoCoord.delete(element.key)
      );
    }

    //Eliminar usuarios asignados a obra
    let usuariosAsignados = await this.usuarioAsignado
      .findByKeyLevantamientoObra(this.obraLevantamientoSeleccionada.key)
      .pipe(take(1))
      .toPromise();
    if (usuariosAsignados) {
      for (let index = 0; index < usuariosAsignados.length; index++) {
        this.usuarioAsignado.delete(usuariosAsignados[index].keyAuto);
      }
    }

    // Elimina obra
    let obra: Obra;
    obra = await this.obraService
      .findByKeyLevantamientoObra(this.obraLevantamientoSeleccionada.key)
      .pipe(take(1))
      .toPromise();
    if (obra) {
      this.obraService.remove(obra.key);
    }

    this.levantamientoObraService
      .deleteObra(this.obraLevantamientoSeleccionada.key)
      .then(() => {
        this.obrasBehaviorSubject$.next(
          this.obrasBehaviorSubject$
            .getValue()
            .filter(
              (obra: AprobacionLevantamientoObraDto) =>
                obra.key !== this.obraLevantamientoSeleccionada.key
            )
        );
        this.cerrarModalBorrarLevantamiento();
        this.alert.closeLoading();
        this.alertasService.mostrarAlerta(
          "success",
          "Registro eliminado correctamente."
        );
      });
  }

  public cerrarModalEliminar() {
    this.modalActivoEliminarObra.close();
  }

  public cerrarModalBorrarLevantamiento() {
    this.modalActivoBorrarLevantamientoObra.close();
  }

  public obtenerInfomarcionRow(datos: AprobacionLevantamientoObraDto) {
    if (this.switch.nativeElement.classList.contains("pi-chevron-right")) {
      this.obtenerCoordenadas(datos);
    }
  }

  public async obtenerCoordenadas(datos: AprobacionLevantamientoObraDto) {
    this.datosObraSeleccionada = datos;
    this.segmentos = [];
    this.segmentos = await this.capaService
      .findByKeyLevantamientoObra(datos.key)
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.datosCoordenadas = this.segmentos[0].coordenadas;
    this.boolInfoMapaLista = true;
    this.obtenerMarcadorInicial();
    this.obtenerMarcadorFinal();
    this.centrarPolyline();
  }

  public obtenerMarcadorInicial(): void {
    this.marcadorInicial = {
      lat: this.segmentos[0].coordenadas[
        this.segmentos[0].coordenadas.length - 1
      ].latitud,
      lng: this.segmentos[0].coordenadas[
        this.segmentos[0].coordenadas.length - 1
      ].longitud,
    };
  }

  public obtenerMarcadorFinal(): void {
    this.marcadorFinal = {
      lat: this.segmentos[0].coordenadas[0].latitud,
      lng: this.segmentos[0].coordenadas[0].longitud,
    };
  }

  public mapReady(event: any): void {
    this.map = event;
    this.centrarPolyline();
    // this.centrarTrazo();
  }

  // public centrarTrazo(): void {
  //   this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.datosCoordenadas));
  // }

  // public crearArregloPolylines(coordenadasElemento: Array<Coordenada[]>): any {
  //   return coordenadasElemento.map((coordenadas: Coordenada[]) => this.crearPolyline(coordenadas))
  // }

  // public crearPolyline(points: Coordenada[]): any {
  //   return {
  //     googlePolylinePoints: points.map(p => ({ lat: p.latitud, lng: p.longitud }))
  //   };
  // }

  public centrarPolyline(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const elementoObra of this.datosCoordenadas) {
      bounds.extend(
        new google.maps.LatLng(elementoObra.latitud, elementoObra.longitud)
      );
    }
    this.map.fitBounds(bounds);
  }

  public cambioZoom(event: any): void {
    this.zoomActual = event;
  }

  public cambioCentro(event: any): void {
    this.latActual = event.lat;
    this.lngActual = event.lng;
  }
}
